/* ============================================================
   O2 Pets – base.js  (loaded globally in theme.liquid)
   Shared utility helpers used by per-section scripts.
   ============================================================ */
const qs  = (sel, ctx = document) => ctx.querySelector(sel);
const qsa = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

